module.exports = __webpack_public_path__ + "images/zoom_landing_mobile-2.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/zoom_landing_mobile-2.png
// module id = 864
// module chunks = 3